export class SolicitudCamViewModel {
    constructor() {}
    public Id: number;
    public IdTipoSolicitudCam: number;
    public IdEstadoSolicitudCam: number;
}

export class TwSolicitudCamViewModelBase {
    public Id?: number;
    public IdCampania: number;
    public IdPeriodoCam: number;
    public IdTipoSolicitudCam: number;
    public IdCa: number;
    public IdEntidadAuditora?: number;
    public AmbitoNacional: boolean;
}

export class TwSolicitudCamViewModel extends TwSolicitudCamViewModelBase {
    public Codigo?: string;
    public IdEstadoSolicitudCam?: number;
    public EstadoSolicitudCam?: string;
    public FechaSolicitud?: Date;
    public FechaCreacion?: Date;
    public FechaAprobacion?: Date;
    public IdUsuario?: number;
    public OperadorRazonSocial: string;
    public OperadorNif: string;
    public OperadorTelefono: string;
    public IdUsuarioModificacion?: number;
    public FechaModificacion?: Date;
    public HasRecintosPIAED?: boolean;
    public PeriodoPresentacionVigente: boolean; // Tiene en cuenta PresentarSolicitudesFueraPeriodo, FechaInicioPresentacion y FechaFinPresentacion
    public PeriodoVigente: boolean; // Tiene en cuenta FechaInicioPeriodo, FechaFinPeriodo y HabilitadaTemporalmente
    public PeriodoSuperficieMax?: number;
    public IdPeriodoPlazoCam?: number;
    public IdAlmacenExportacionCicloCorto?: number;
    public AlmacenExportacionCicloCorto?: string;
}

export function equalObjects(obj1: any, obj2: any) {
    return (
        obj1 &&
        obj2 &&
        Object.keys(obj1).length === Object.keys(obj2).length &&
        (Object.keys(obj1) as (keyof typeof obj1)[]).every(key => {
            return Object.prototype.hasOwnProperty.call(obj2, key) && obj1[key] === obj2[key];
        })
    );
}

export class TwSolicitudCamViewModelExtended extends TwSolicitudCamViewModel {
    public Campania: string;
    public Periodo: string;
    public DescripcionComunidad: string;
    public EntidadAuditora: string;
    public TipoSolicitudCam: string;
}

export class EnviarSolicitudViewModel {
    public IdSolicitudCam: number;
    public IdTipoSolicitudCam: number;
    public IdAlmacenExportacionCicloCorto: number;
    public IdUsuario?: number;
}

export class ValidacionAceptacionSolicitudViewModel {
    public IdSolicitudCam: number;
    public IdTipoSolicitudCam: number;
    public ObservacionesValidacion: string;
    public ObservacionesAceptacion: string;
    public IdEstadoValidacionEa?: number;
    public IdEstadoValidacionCa?: number;
    public IdEstadoAceptacion?: number;
}

export class TwSolicitudCamValidationViewModel extends TwSolicitudCamViewModel {
    public validacionData: TwValidacionSolicitudCamViewModel;
    public aceptacionData: TwAceptacionSolicitudCamViewModel;
}

export class TwValidacionSolicitudCamViewModel {
    public IdSolicitudCam: number;
    public IdEstadoValidacionEa?: number;
    public IdEstadoValidacionCa?: number;
    public IdUsuarioValidacionTecnicoEa?: number;
    public UsuarioValidacionTecnicoEa: string;
    public IdUsuarioValidacionCa?: number;
    public UsuarioValidacionCa: string;
    public Fecha?: Date;
    public Observaciones: string;
}

export class TwAceptacionSolicitudCamViewModel {
    public IdSolicitudCam: number;
    public IdEstadoAceptacion?: number;
    public IdUsuarioCa?: number;
    public UsuarioCa: string;
    public Fecha?: Date;
    public Observaciones: string;
}
